import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AllocationItemByIdMap, FetchingStatus, IAllocationItemStore, IVideoManagementState } from './interfaces';
import { addTimeToCurrentTerm, createNewTerm, deleteTerm, getManageMinutesList, updateTerm } from './thunk';

export const initialState: IVideoManagementState = {
  addMinutesToCurrentTermStatus: FetchingStatus.Idle,
  creatingNewTermStatus: FetchingStatus.Idle,
  deleteTermStatus: FetchingStatus.Idle,
  fetchingManagementListStatus: FetchingStatus.Idle,
  idsList: [],
  isModalOpen: false,
  map: {},
  updateTermStatus: FetchingStatus.Idle
};

const videoManagementSlice = createSlice({
  name: 'management',
  initialState,
  reducers: {
    openDrawer: (state: IVideoManagementState) => {
      state.isModalOpen = true;
    },
    closeDrawer: (state: IVideoManagementState) => {
      state.isModalOpen = false;
    }
  },
  extraReducers: {
    [createNewTerm?.fulfilled.type]: (state) => {
      state.creatingNewTermStatus = FetchingStatus.Succeeded;
    },
    [createNewTerm?.pending.type]: (state) => {
      state.creatingNewTermStatus = FetchingStatus.Loading;
    },
    [createNewTerm?.rejected.type]: (state) => {
      state.creatingNewTermStatus = FetchingStatus.Failed;
    },
    [getManageMinutesList?.pending.type]: (state) => {
      state.fetchingManagementListStatus = FetchingStatus.Loading;
    },
    [getManageMinutesList?.rejected.type]: (state) => {
      state.fetchingManagementListStatus = FetchingStatus.Failed;
    },
    [getManageMinutesList?.fulfilled.type]: (state, action: PayloadAction<IAllocationItemStore[]>) => {
      const list = action.payload;
      const dictionaryOfAllItems: AllocationItemByIdMap = {};
      state.fetchingManagementListStatus = FetchingStatus.Succeeded;
      state.idsList = list.map((item) => {
        const { id } = item;
        dictionaryOfAllItems[id] = item;
        return id;
      });
      state.map = dictionaryOfAllItems;
    },
    [addTimeToCurrentTerm?.fulfilled.type]: (state) => {
      state.addMinutesToCurrentTermStatus = FetchingStatus.Succeeded;
    },
    [addTimeToCurrentTerm?.pending.type]: (state) => {
      state.addMinutesToCurrentTermStatus = FetchingStatus.Loading;
    },
    [addTimeToCurrentTerm?.rejected.type]: (state) => {
      state.addMinutesToCurrentTermStatus = FetchingStatus.Failed;
    },
    [deleteTerm?.fulfilled.type]: (state) => {
      state.deleteTermStatus = FetchingStatus.Succeeded;
    },
    [deleteTerm?.pending.type]: (state) => {
      state.deleteTermStatus = FetchingStatus.Loading;
    },
    [deleteTerm?.rejected.type]: (state) => {
      state.deleteTermStatus = FetchingStatus.Failed;
    },
    [updateTerm?.fulfilled.type]: (state) => {
      state.updateTermStatus = FetchingStatus.Succeeded;
    },
    [updateTerm?.pending.type]: (state) => {
      state.updateTermStatus = FetchingStatus.Loading;
    },
    [updateTerm?.rejected.type]: (state) => {
      state.updateTermStatus = FetchingStatus.Failed;
    }
  }
});

export const {
  closeDrawer,
  openDrawer
} = videoManagementSlice.actions;

export const videoManagementReducer = videoManagementSlice.reducer;
